import styled from 'styled-components';
import { Row } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const Breadcrumb = styled.div`
	width: 100%;
	display: flex;

	a {
		margin-right: 10px;
		text-decoration: none !important;

		&:hover {
			opacity: 0.8;
		}

		&:after {
			content: '/';
			display: block;
			margin-left: 10px;
		}

		&:last-child {
			margin-right: 0;
			&:after {
				display: none;
			}
		}
	}
`;

export const StyledRow = styled(Row)`
	font-size: 14px;

	svg {
		color: ${color.secondary};
	}

	a {
		font-weight: bold;
	}
`;

export const StyledLink = styled.a`
	border-radius: 50px;
	background-color: ${color.yellow};

	padding-top: 3px;
	padding-right: 15px;
	padding-bottom: 3px;
	padding-left: 15px;

	:visited {
    	color: ${color.softBlack};
	}
`;
